module.exports = __webpack_public_path__ + "static/media/gray.b111b147.svg";